import React from "react"
import styled, { css } from "styled-components"

import { media } from "../styles"

const HeaderNavToggleButton = styled.button`
  appearance: none;
  background: transparent;
  border: none;
  color: ${({ theme }) =>
    theme.name === "dark" ? theme.brandPrimaryLight : theme.brandPrimaryDark};
  cursor: pointer;
  padding: 8px;
  position: relative;
  margin: 0 -8px 0 20px;
  order: 2;
  z-index: 10;

  ${(props) =>
    props.open &&
    css`
      color: ${({ theme }) => theme.brandPrimaryLight};
    `}

  svg {
    display: block;
    height: 21px;
    width: 26px;

    @media ${media.md} {
      height: 26px;
      width: 35px;
    }
  }

  @media ${media.lg} {
    display: none;
  }
`

const HeaderNavToggle = ({ open, handleToggle }) => {
  return (
    <HeaderNavToggleButton onClick={() => handleToggle()} open={open}>
      {open ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
        >
          <g fill="currentColor" fillRule="evenodd">
            <path d="M.1005 17.071L17.0711.1006l2.8284 2.8284L2.9289 19.8995z" />
            <path d="M17.071 19.8995L.1006 2.9289 2.929.1005l16.9706 16.9706z" />
          </g>
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="21"
          viewBox="0 0 26 21"
        >
          <g fill="currentColor" fillRule="evenodd">
            <rect width="26" height="3.231" />
            <rect width="26" height="3.231" y="8.885" />
            <rect width="26" height="3.231" y="17.769" />
          </g>
        </svg>
      )}
    </HeaderNavToggleButton>
  )
}

export default HeaderNavToggle
